export enum ELanguage {
	russian,
	azerbaijani,
	english
}